import React from "react"

const IconCaretRight = () => (
    <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.136 4.55L2.022 0.824H0.402L3.408 4.532L0.456 8.294H2.112L5.136 4.55Z" fill="currentColor"/>
    </svg>
)

export default IconCaretRight